// deps
import styled, { keyframes } from "styled-components";

// internal-deps
import { default as ArrowIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/arrowFront/16";

const ACCENT_COLOR = "#018029";

const letterIn = keyframes`
    0% {
        color: ${ACCENT_COLOR};
        transform: translateY(6px) scale(0.7);
        opacity: 0;
    }
    40% {
        color: ${ACCENT_COLOR};
        transform: translateY(-1px) scale(1.08);
        opacity: 1;
    }
    100% {
        color: inherit;
        transform: translateY(0) scale(1);
        opacity: 1;
    }
`;

export const AnimatedChar = styled.span<{ $index: number }>`
    display: inline-block;
    color: ${ACCENT_COLOR};
    opacity: 0;
    transform: translateY(6px) scale(0.7);
    animation: ${letterIn} 420ms cubic-bezier(0.2, 0.9, 0.3, 1.35) forwards;
    animation-delay: ${(props) => 300 + props.$index * 28}ms;
    will-change: transform, opacity;
`;

export const StaticChar = styled.span<{ $index: number }>`
    display: inline-block;
    transform: translateY(0) scale(1);
    opacity: 1;
`;

const bounce = keyframes`
    0% {
        transform: translateY(-4px) rotate(90deg);
    }
    100% {
        transform: translateY(4px) rotate(90deg);
    }
`;

export const DownArrowIcon = styled(ArrowIcon)`
    fill: ${(props) => props.theme.colors.light.background_Add_Button};
    margin-left: ${(props) => props.theme.spacing.large};
    transform: rotate(90deg);
    animation: ${bounce} 0.6s linear infinite alternate;
`;

export const StyledNewTagWrapper = styled.div(({ theme }) => ({
    marginRight: theme.spacing.xSmall,
}));
